'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import { useMemo, useState } from 'react'

/* -----------------------------------------------------------------------------
 * useHover
 *
 * react-native-web has no `:hover`, so the design's hover states are driven by
 * mouse events. `Pressable` already declares onMouseEnter/onMouseLeave; `Box`
 * forwards unknown props through to the underlying element.
 * -------------------------------------------------------------------------- */

const useHover = () => {
  const [isHovered, setIsHovered] = useState(false)

  const hoverProps = useMemo(
    () => ({
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false)
    }),
    []
  )

  return { hoverProps, isHovered }
}

export default useHover
